import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-results-compare',
  templateUrl: './results-compare.component.html',
  styleUrls: ['./results-compare.component.css'],
})
export class ResultsCompareComponent {
  candidateIds: number[] = [];
  idclientConnected = this.localStorageService.getData('clientConnected');
  candidatsList: any;
  companyType: any;
  currentUser: any;
  private unsubscribeAll: Subject<void> = new Subject();

  constructor(
    private activatedRoute: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private router: Router
  ) {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state?.['data']) {
      this.candidatsList = navigation.extras.state['data'];
      this.candidateIds = this.candidatsList.map((candidate: { candidate_id: number;}) => candidate.candidate_id);
    } else {
      this.router.navigate(['/candidats/list-candidats']);
    }
  }

  ngOnInit() {
    this.getcurrentUser();
  }

  getcurrentUser() {
    this.currentUser = this.localStorageService.getData('UserInfo');
    this.companyType = JSON.parse(this.currentUser).company.type;
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  updateScale(){
    this.router.navigate([
      '/candidats/compare-candidats',
      { candidatsIds: this.candidateIds },
    ]);
  }

  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
